// extracted by mini-css-extract-plugin
export default {"referral-widget":"Mp","referral-page":"Np","label":"Op","subHed":"Pp","profile-container":"Qp","referral-container":"Rp","referral-header":"Sp","shareMethodRow":"Tp","shareMethod":"Up","active":"Vp","referral-stat":"Wp","blockwrapper":"Xp","referralLink":"Yp","bold":"Zp","semibold":"aq","shareAgainButton":"bq","policy":"cq","narrowWrapper":"eq"};
    if(module.hot) {
      // 1721922359503
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  